/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */

export enum ModulesEnum {
    CENTRALISED_MANAGEMENT,
    CENTRALISED_MANAGEMENT_ON_PREMISE,
    LOADBALANCER,
    DEEPTHOUGHT
}

export const environment = {
    production: false,
    name: 'Loadbalancer.org Ltd.',
    module: ModulesEnum.CENTRALISED_MANAGEMENT,
    theme: 'default',
    helpDrawActive: true,
    externalResourceUrl: 'https://web.lborg.dev/portal/',
    stripeDisabled: false
};
